import { motion } from "framer-motion";
import { HERO_VIDEO } from "@/data/content";
import { ArrowDown } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

export const Hero = () => {
  const scrollTo = (href) =>
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative h-screen min-h-[680px] w-full overflow-hidden film-grain"
    >
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        data-testid="hero-video"
      >
        <source src={HERO_VIDEO} type="video/mp4" />
      </video>

      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70" />

      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 sm:px-12 flex flex-col justify-end pb-20 sm:pb-28">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: EASE, delay: 0.3 }}
          className="overline text-[#C9BCA8] mb-6"
        >
          Cinematic Property Films
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.4, ease: EASE, delay: 0.45 }}
          className="font-display font-light text-[#F7F5F0] text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight max-w-5xl"
          data-testid="hero-headline"
        >
          Transform Property Photography Into Cinematic Listing Videos
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: EASE, delay: 0.7 }}
          className="mt-8 max-w-xl text-[#F7F5F0]/80 text-base sm:text-lg leading-relaxed font-light"
        >
          We compose films from the professional photography you already own -
          guided by advanced AI and shaped by human editors. No reshoot required.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: EASE, delay: 0.9 }}
          className="mt-10 flex flex-wrap items-center gap-5"
        >
          <button
            data-testid="hero-cta-work"
            onClick={() => scrollTo("#work")}
            className="bg-[#F7F5F0] text-[#1A1A1A] px-9 py-4 text-xs tracking-[0.18em] uppercase hover:bg-accent hover:text-[#F7F5F0] transition-all duration-300"
          >
            View the Films
          </button>
          <button
            data-testid="hero-cta-contact"
            onClick={() => scrollTo("#contact")}
            className="text-[#F7F5F0] px-9 py-4 text-xs tracking-[0.18em] uppercase border border-[#F7F5F0]/40 hover:border-[#F7F5F0] transition-all duration-300"
          >
            Commission a Film
          </button>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.4 }}
        className="absolute bottom-8 right-6 sm:right-12 z-10 text-[#F7F5F0]/70"
      >
        <ArrowDown strokeWidth={1} className="animate-bounce" />
      </motion.div>
    </section>
  );
};

export default Hero;
